import { useContext } from "react";
import { Menu as MenuIcon } from "lucide-react";
import { SideMenuContext } from "../../contexts/SideMenuContext";

interface UpperMenuProps {
  title: string;
}

const subtitleByTitle: Record<string, string> = {
  Plataforma: "Visão geral da sua conta Maritaca AI",
  Modelos: "Catálogo de modelos disponíveis",
  Preços: "Tabela de preços por modelo",
  "Rate Limits": "Limites de requisições por minuto",
  Gastos: "Histórico de consumo da sua conta",
  "Chaves de API": "Gerencie suas credenciais para integrações",
  Organizações: "Times e permissões compartilhadas",
  Recarga: "Adicionar créditos à conta",
  Comprovantes: "Notas e recibos de pagamento",
  "Batch API": "Processamento em lote de requisições",
  Arquivos: "Upload e gestão de arquivos",
  Playground: "Teste e compare modelos lado a lado",
};

export default function UpperMenu({ title }: UpperMenuProps) {
  const { isSideMenuCollapsed, setIsSideMenuCollapsed } = useContext(SideMenuContext);
  const subtitle = subtitleByTitle[title] ?? "";

  return (
    <header className="sticky top-0 z-30 border-b border-border bg-background">
      <div className="flex items-center gap-3 px-6 py-4 md:px-8">
        <button
          onClick={() => setIsSideMenuCollapsed(!isSideMenuCollapsed)}
          aria-label="Abrir menu"
          className="flex h-8 w-8 items-center justify-center rounded-md border border-border text-foreground transition-colors hover:bg-muted md:hidden"
        >
          <MenuIcon className="h-4 w-4" />
        </button>

        <div className="min-w-0 flex-1">
          <h1 className="truncate text-[20px] font-semibold tracking-tight text-foreground">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-0.5 truncate text-[13px] text-muted-foreground">{subtitle}</p>
          )}
        </div>
      </div>
    </header>
  );
}
